import React, { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};
  if (!values.code?.trim()) errors.code = "Code is required";
  if (!values.typeName?.trim()) errors.typeName = "Type Name is required";
  return errors;
};

const EditDocType = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = useState(false);

  return (
    <Dialog
      title={ADD_NEW ? "Add Document Type" : `Edit ${props?.item?.typeName}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <>
        <Form
          onSubmit={props.onSubmit}
          initialValues={{ active: true, ...props.item }}
          validator={validateForm}
          render={(formRenderProps) => (
            <>
              <FormElement style={{ maxWidth: 1200 }}>
                <fieldset className="p-3 ps-4">
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Code&nbsp;</Label>
                    <Field
                      name={"code"}
                      component={Input}
                      placeholder="Enter Code"
                      maxLength={2}
                    />
                    {submitAttempted && formRenderProps.errors?.code && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.code}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Type Name&nbsp;
                    </Label>
                    <Field
                      name={"typeName"}
                      placeholder="Enter Name"
                      component={Input}
                    />
                    {submitAttempted && formRenderProps.errors?.typeName && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.typeName}</i>
                      </div>
                    )}
                  </div>
                  <Field
                    name={"active"}
                    component={Checkbox}
                    label={"Active"}
                  />
                </fieldset>
              </FormElement>

              <div className="dialog-footer">
                <Button
                  className="common-btn bgBtnSecondary me-2"
                  onClick={props.cancelEdit}
                >
                  Cancel
                </Button>
                <SubmitButton
                  className="common-btn me-3"
                  onClick={() => {
                    setSubmitAttempted(true);
                    formRenderProps.onSubmit();
                  }}
                  disabled={!formRenderProps.allowSubmit}
                  isLoading={props.isSubmitting}
                >
                  {ADD_NEW ? "Save" : "Update"}
                </SubmitButton>
              </div>
            </>
          )}
        />
      </>
    </Dialog>
  );
};

export default EditDocType;
